import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import BackgroundItem from './BackgroundItem';

var Background = /*#__PURE__*/function (_React$Component) {
  _inherits(Background, _React$Component);

  var _super = _createSuper(Background);

  function Background(props) {
    var _props$background;

    var _this;

    _classCallCheck(this, Background);

    _this = _super.call(this, props);

    _this.handleResize = function () {
      // Debounce resize events
      clearTimeout(_this.resizeTimeout);
      _this.resizeTimeout = setTimeout(function () {
        _this.initializeBackground();
      }, 250);
    };

    _this.initializeBackground = function () {
      // Calculate height from header, main, and footer elements
      var header = document.querySelector('header');
      var main = document.querySelector('main');
      var footer = document.querySelector('footer');
      var totalHeight = 0;

      if (header) {
        totalHeight += header.offsetHeight;
      }

      if (main) {
        totalHeight += main.offsetHeight;
      }

      if (footer) {
        totalHeight += footer.offsetHeight;
      }

      _this.height = totalHeight;
      _this.itemSpace = _this.state.dimensions.height ? _this.state.dimensions.height + 100 : 500;

      if (!Number.isInteger(_this.height) || _this.height <= 0) {
        _this.height = _this.itemSpace;
      }

      var itemCount = Math.floor(_this.height / _this.itemSpace);

      if (!Number.isInteger(itemCount) || itemCount <= 0) {
        itemCount = 1;
      }

      _this.itemCount = itemCount;

      _this.setState({
        pattern: _this.buildPattern()
      });
    };

    _this.image = props.background ? (_props$background = props.background) === null || _props$background === void 0 ? void 0 : _props$background.src : null;
    _this.state = {
      pattern: [],
      dimensions: {}
    };
    _this.height = 100; // Set an initial arbitrary height;
    // const sides = [
    //   'left',
    //   'right'
    // ];

    _this.speeds = [-1.1, -0.75 - 0.4, 0.2, 0.9, 1.2];
    _this.itemSpace = 340; // Distance offset between each item
    // let spaced = 200;

    _this.onImgLoad = _this.onImgLoad.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Background, [{
    key: "setPosition",
    value: function setPosition(index) {
      var itemSpace = this.itemSpace;
      var offset = 200 + itemSpace;
      var rule = 'left';
      var rules = {
        top: index <= 0 ? "200px" : "".concat(offset + itemSpace * index, "px") // Set initial offset

      };
      rules[rule] = 0;
      return rules;
    }
  }, {
    key: "buildPattern",
    value: function buildPattern() {
      var _this2 = this;

      var pattern = [];
      var speeds = this.speeds;
      var speedCounter = 0;

      if (!this.image) {
        return pattern;
      }

      Array.from(Array(this.itemCount), function (e, index) {
        speedCounter = speedCounter <= speeds.length - 1 ? speedCounter : 0;
        pattern.push({
          image: _this2.image,
          speed: -1.9 // speed: speeds[speedCounter]

        });
        speedCounter++;
      });
      var test = Object.assign.apply(Object, [{}].concat(pattern));
      return pattern; //(pattern.length > 1) ? pattern.splice(-1) : pattern;
    }
  }, {
    key: "onImgLoad",
    value: function onImgLoad(_ref) {
      var img = _ref.target;
      this.setState({
        dimensions: {
          height: img.offsetHeight,
          width: img.offsetWidth
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // Wait for window to be fully loaded
      if (document.readyState === 'complete') {
        this.initializeBackground();
      } else {
        window.addEventListener('load', this.initializeBackground);
      } // Also listen for resize events


      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('load', this.initializeBackground);
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "cb-background"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cb-background__parallax",
        style: {
          height: this.height
        }
      }, this.state.pattern && this.state.pattern.map(function (item, index) {
        var position = _this3.setPosition(index);

        return /*#__PURE__*/React.createElement(React.Fragment, null, typeof _this3.state.dimensions.height !== 'undefined' ? /*#__PURE__*/React.createElement("img", {
          key: "temp-bg-".concat(index),
          onLoad: _this3.onImgLoad,
          src: item.image,
          style: {
            'opacity': '0'
          }
        }) : null, /*#__PURE__*/React.createElement(BackgroundItem, {
          key: "background-".concat(index),
          speed: item.speed,
          image: item.image,
          position: position
        }));
      }))));
    }
  }]);

  return Background;
}(React.Component);

export default Background;